const authToastMsg = {
  /**
   *  로그인
   */
  LOGIN_SUCCESS: '로그인 성공',
  LOGIN_ERROR: '로그인 실패',
};

export default authToastMsg;
